import {IJobUsersDetails,IJobUserDetailsActionCreator,IJobUserDetailsActionTypes} from 'models/IUserDetailsForJobState';

const initialState:IJobUsersDetails = {}

const reducer = (state = initialState, { type, payload }: IJobUserDetailsActionCreator) => {
    switch (type) {
      case IJobUserDetailsActionTypes.FETCH_USER_DETAILS_FOR_JOB_REQUEST:
        return {
          ...state,
          data:{},
        }
      case IJobUserDetailsActionTypes.FETCH_USER_DETAILS_FOR_JOB_SUCCESS:
        return {
          ...state,
          ...payload
        }
      default:
        return state;
    }
  };
  
  export default reducer;